// InitialValuePlugin.tsx
import {useLexicalComposerContext} from "@lexical/react/LexicalComposerContext";
import {useEffect, useRef} from "react";
import { $getRoot, $createParagraphNode, $createTextNode } from "lexical";

export default function InitialValuePlugin({
  value,
  overwriteOnChange = false, 
}) {
  const [editor] = useLexicalComposerContext();
  const didSetOnce = useRef(false);

  useEffect(() => {
    if (value == null) return;

    editor.update(() => {
      const root = $getRoot();
      const textIsEmpty = root.getTextContentSize() === 0;

      // Overwrite on first run OR when explicitly requested OR when editor has no text
      if (!didSetOnce.current || overwriteOnChange || textIsEmpty) {
        root.clear();
        const p = $createParagraphNode();
        p.append($createTextNode(value || ""));
        root.append(p);
        didSetOnce.current = true;
      }
    });
  }, [editor, value, overwriteOnChange]);

  return null;
}
